<template>
  <height-tracker class="container-fluid" style="overflow: hidden;">
    <div class="table-full-width" slot-scope="{ height }">
      <data-table
        v-bind="$attrs"
        v-on="$listeners"
        :height="height"
        style="width: 100%; position: absolute; left: 0; top: 0;"
        :currency-symbol="getCurrencySymbols()"
        :table-column-type="getTableColumnTypes()"
      >
        <slot/>
      </data-table>
    </div>
  </height-tracker>
</template>

<script>
  export default {
    name: 'data-table-full-height',
    methods: {
      getCurrencySymbols() {
        const symbols = [];
        this.$slots.default.forEach((vnode) => {
          if (vnode.componentOptions && vnode.componentOptions.propsData) {
            symbols.push(vnode.componentOptions.propsData.currencySymbol);
          }
        });
        return symbols;
      },
      getTableColumnTypes() {
        const types = [];
        this.$slots.default.forEach((vnode) => {
          if (vnode.componentOptions && vnode.componentOptions.propsData) {
            types.push(vnode.componentOptions.propsData.tableColumnType);
          }
        });
        return types;
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/data-table-full-height.vue